import { render, staticRenderFns } from "./ScreensListFilters.vue?vue&type=template&id=226ef2ed&"
import script from "./ScreensListFilters.vue?vue&type=script&lang=js&"
export * from "./ScreensListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports